import { useMemo, useCallback } from 'react';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import {
  getDemoContractById as rawGetDemoContractById,
  DEMO_CONTRACT_IDS,
  musicIndustryContracts,
  demoContractSignData,
} from '@/mockData/demoContractData';
import type { GetContractResponseContent } from '@/types/contract.types';

export function useDemoContractAnalysis() {
  const isDemo = useIsDemo();

  const getDemoContractById = useCallback(
    (contractId: string): GetContractResponseContent | undefined =>
      isDemo ? rawGetDemoContractById(contractId) : undefined,
    [isDemo],
  );

  const demoContractIds = useMemo(
    () => (isDemo ? DEMO_CONTRACT_IDS : ({} as typeof DEMO_CONTRACT_IDS)),
    [isDemo],
  );

  const contracts = useMemo(
    () => (isDemo ? musicIndustryContracts : []),
    [isDemo],
  );

  const contractSignData = useMemo(
    () => (isDemo ? demoContractSignData : ({} as typeof demoContractSignData)),
    [isDemo],
  );

  return {
    getDemoContractById,
    demoContractIds,
    musicIndustryContracts: contracts,
    demoContractSignData: contractSignData,
  };
}
